<script setup lang="ts">
import { routes } from "/assets/routes.ts";
import { useWindowSize } from "@vueuse/core";
const { width: windowW } = useWindowSize();

const route = useRoute();
const page = qsDecode(route.path.split("/")[1]);
const header = qsDecode(route.path.split("/")[2]);
function capitalizeFirstLetter(string) {
  return string?.slice(0, 1).toUpperCase() + string.slice(1);
}
const thisSubheader = computed(() => {
  return qsDecode(route.path.split("/")[3]);
});

const thisIndex = computed(() => {
  return routes[page][header].indexOf(thisSubheader.value);
});

const subheaderOffset = computed(() => {
  if (windowW.value < 800) return thisIndex.value * -10 + "vw";
  if (thisIndex.value === 0) return 0;
  return thisIndex.value * -5 + "ch";
});
</script>

<template>
  <div>
    <nav
      v-if="header"
      class="subheader flex whitespace-nowrap gap-4 h-8 flex-shrink-0 page-padding-x overflow-x-visible transition-all duration-300"
      :style="`transform: translateX(${subheaderOffset});`"
    >
      <nuxt-link
        v-for="subheader in routes[page][header]"
        :key="subheader"
        :class="subheader === thisSubheader ? 'opacity-100' : 'opacity-40'"
        :to="qsEncode(subheader)"
        >{{ subheader && capitalizeFirstLetter(subheader) }}
      </nuxt-link>
    </nav>
    <div v-else class="h-8"></div>
    <div
      id="header-slot"
      class="page-padding-x"
      style="
        height: calc(100vh - 10rem);
        width: calc(100vw - 2.5rem);
        overflow-y: auto;
      "
    >
      <slot></slot>
    </div>
  </div>
</template>

<style>
#subheader-slot div {
  /* min-height: calc(100vh - 5rem); */
}

.subheader-left-enter-active,
.subheader-right-enter-active,
.subheader-left-leave-active,
.subheader-right-leave-active {
  position: fixed;
  top: 9.74rem;
  left: -1.5rem;
  right: 0;
  padding-left: 1.5rem;
  padding-right: 1rem;
  transition:
    transform 250ms ease-out,
    opacity 100ms 200ms ease-in;
  width: 100vw;
  @media (min-width: 768px) {
    left: -4rem;
    padding: 0 4rem;
  }
}

.subheader-left-enter-from,
.subheader-right-leave-to {
  transform: translateX(100%);
}

.subheader-left-leave-to,
.subheader-right-enter-from {
  transform: translateX(-100%);
}

.subheader-left-enter-to,
.subheader-right-enter-to {
  transform: translateX(1.5rem);
  @media (min-width: 768px) {
    transform: translateX(3.5rem);
  }
}
</style>
